import authenticationService from '../../../services/authentication/AuthenticationService';
import {getClients, getInvitations, getDepositor} from './dataGetters';

export default (params, fetchNotifications) => {
  const roles = authenticationService.roles();
  const isConsultant = roles.isConsultant();
  const isExplorer = roles.isExplorer();

  const updateDepositorAndClients = async dispatch => {
    const depositor = await getDepositor(params.organisationId);
    dispatch({type: 'UPDATE_DEPOSITOR', depositor});
    try {
      const {clients, totalCount} = await getClients(params);
      dispatch({type: 'UPDATE_CLIENTS', clients, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'clients'});
    }
  };

  return {
    FETCH_DATA: ({dispatch}) => async () => {
      dispatch({type: 'START_LOADING_ALL'});
      updateDepositorAndClients(dispatch);
      fetchNotifications({organisationId: params.organisationId, depositor: params.depositor});

      if (!isConsultant && !isExplorer) {
        try {
          const sentInvitations = await getInvitations(params.organisationId) || [];
          dispatch({type: 'UPDATE_INVITATIONS', sentInvitations});
        } catch {
          dispatch({type: 'ERROR', key: 'sentInvitations'});
        }
      }
    },
    FETCH_CLIENTS: ({dispatch}) => async () => {
      dispatch({type: 'START_LOADING', keys: ['clients']});
      updateDepositorAndClients(dispatch);
    }
  };
};
